import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Homepage/Home";
import PlotMarket from "../pages/Plot_marketPlace/plot_market";
import GiooPlot from "../pages/GIOO_Plots/Gioo_plot";
import SyndicatePlots from "../pages/Syndicate_Plots/SyndicatePlots";
import Professional_servie from "../pages/Professional Service/ProfessionalService";
import Gioo_plots_property from "../pages/GIOO_Plots/Gioo_plots_property";
import MaterialStore from "../pages/Material Store/MaterialStore";
import ProductDetails from "../pages/Material Store/ProductView";
import LoginModal from "../pages/Login/login";
import SignupModal from "../pages/SignUp/Signup";
import Professionalservice from "../pages/Professional Service/ProfessionalService";
import SyndicateProperty from "../pages/Syndicate_Plots/Syndicate_property";
import PlotMarketDetails from "../pages/Plot_marketPlace/plot_market_details";
import ProfileScreen from "../pages/profile/profile";
import Dashboard from "../pages/profile/Dashboard";
import Account from "../pages/profile/Account";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../context/LoginDetail";
import ProtectedRoute from "./ProtectedRoute";
import PurchaseList from "../pages/profile/MenuPages/PurchaseList";
import MaterialEnquiryList from "../pages/profile/MenuPages/MaterialEnquiryList";
import ServiceEnquiryList from "../pages/profile/MenuPages/ServiceEnquiryList";
import MyProperty from "../pages/profile/MenuPages/MyProperty";
import AddPropertyForm from "../pages/profile/MenuPages/AddPropertyForm";
import ResidentialProperty from "../pages/Residential_Properties/ResidentialProperty";
import ResidentialPlotsDetail from "../pages/Residential_Properties/ResidentialPlotsDetail";
import MyResidentialList from "../pages/profile/MenuPages/MyResidentialList";
import AddResidential from "../pages/profile/MenuPages/AddResidential";
import ResidentialEnqueryList from "../pages/profile/MenuPages/ResidentialEnqueryList";
import RentalYieldPlot from "../pages/RentalYield/RentalYieldPlot";
import RentalYieldDetail from "../pages/RentalYield/RentalYieldDetail";
import RentalEnquiry from "../pages/profile/MenuPages/RentalEnquiry";
import About from "../pages/profile/MenuPages/About";
import Wallet from "../pages/profile/MenuPages/Wallet";
import PurchaseCoupon from "../pages/profile/MenuPages/PurchaseCoupon";
import KYCForm from "../pages/profile/MenuPages/KYCForm";
import Encashment from "../pages/profile/MenuPages/Enchashment";
import Transactions from "../pages/profile/MenuPages/Transactions";
import { Box } from "@mui/material";
import StaticPage from "../components/common/StaticPage";
import ContactUs from "../components/footer/ContactUs";
import StaticTermsPage from "../components/common/StaticTermsPage";
import MarketinPlaceEnquiry from "../pages/profile/MenuPages/MarketinPlaceEnquiry";
import MaterialVendorAddProperty from "../pages/profile/MenuPages/MaterialVendorAddProperty";
// import MaterialServiceAddProperty from "../pages/profile/MenuPages/MaterialServiceAddProperty";
import MaterialProductCardDetail from "../pages/Material Store/MaterialProductCardDetail";
import MaterialStoreShop from "../pages/Material Store/MaterialStoreShop";
import ProfessionalServiceShop from "../pages/Professional Service/ProfessionalServiceShop";
import ProfessionalServiceDetail from "../pages/Professional Service/ProfessionalServiceDetail";
import AddMaterialForm from "../pages/profile/MenuPages/AddMaterialForm";
import AddServiceForm from "../pages/profile/MenuPages/AddServiceForm";
import SearchResults from "../pages/Homepage/SearchResults";
import Notifications from "../pages/profile/MenuPages/Notifications";
import AccountDetails from "../pages/profile/MenuPages/AccountDetails";
import MyMaterialEnquiryList from "../pages/profile/MenuPages/MyMaterialEnquiryList";
import MyServiceEnquiryList from "../pages/profile/MenuPages/MyServiceEnquiryList";
import GeneralEnquiry from "../pages/profile/MenuPages/GeneralEnquiry";
import CustomLandEnquiry from "../pages/profile/MenuPages/CustomLandEnquiry";

const AppRoutes = () => {
 
  //for scroll
  const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const scrollToTarget = () => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
            return true;
          }
          return false;
        };

        if (!scrollToTarget()) {
          const timer = setTimeout(scrollToTarget, 300);
          return () => clearTimeout(timer);
        }
      } else {
        window.scrollTo(0, 0);
        window.history.scrollRestoration = "manual";
      }
    }, [pathname, hash]);
  };


  return (
    <>
      <ScrollToTop />
      <Routes>

        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/plot-marketplace" element={<PlotMarket />} />
        <Route path="/gioo-plots" element={<GiooPlot />} />
        <Route path="/gioo-plots/details/:id" element={<Gioo_plots_property />} />
        <Route path="/syndicate-plots" element={<SyndicatePlots />} />
        <Route path="/syndicate-plots/details/:id" element={<SyndicateProperty />} />
        <Route path="/rental-yield-plots" element={<RentalYieldPlot />} />
        <Route path="/rental-yield-plots/details/:id" element={<RentalYieldDetail />} />

        <Route path="/material-store" element={<MaterialStore />} />
        <Route path="/material-store/shop/:id" element={<MaterialStoreShop />} />
        <Route path="/material-store/detail/:id" element={<MaterialProductCardDetail />} />

        <Route path="/professional-services" element={<Professionalservice />} />
        <Route path="/professional-services/services/:id" element={<ProfessionalServiceShop />} />
        <Route path="/professional-services/detail/:id" element={<ProfessionalServiceDetail />} />

        <Route path="/flats-villas/details/:id" element={<ResidentialPlotsDetail />} />
        <Route path="/plot-marketplace/details/:id" element={<PlotMarketDetails />} />
        <Route path="/flats-villas" element={<ResidentialProperty />} />
        <Route path="/about" element={<About />} />
        <Route path="/pages/:slug" element={<StaticPage />} />
        <Route path="/terms/:slug" element={<StaticTermsPage />} />

        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/search" element={<SearchResults />} />

        {/* <Route path="/dashboard/about" element={<About/>}/> */}

        {/* Protected Routes */}

        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <ProfileScreen />
            </ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="my-dashboard" element={<Dashboard />} />
          <Route path="account" element={<Account />} />
          <Route path="my-wallet" element={<Wallet />} />
          <Route path="marketingplace-enquiry" element={<MarketinPlaceEnquiry />} />
          <Route path="material-enquiry" element={<MaterialEnquiryList />} />
          <Route path="service-enquiry" element={<ServiceEnquiryList />} />
          <Route path="my-material-enquiry" element={<MyMaterialEnquiryList />} />
          <Route path="my-service-enquiry" element={<MyServiceEnquiryList />} />
          <Route path="residential_enquiry" element={<ResidentialEnqueryList />} />
          <Route path="rental_enquiry" element={<RentalEnquiry />} />
          <Route path="my_markplace_plot" element={<MyProperty />} />
          <Route path="my_residential_property" element={<MyResidentialList />} />
          <Route path="buying-list" element={<PurchaseList />} />
           <Route path="kyc-details" element={<KYCForm />} />
           <Route path="general-enquiry" element={<GeneralEnquiry />} />
           <Route path="custom-land-enquiry" element={<CustomLandEnquiry />} />
           <Route path="account-details" element={<AccountDetails />} />
          <Route path="Purchase-coupon" element={<PurchaseCoupon />} />
          <Route path="encashment" element={<Encashment />} />
          <Route path="transactions" element={<Transactions />} />
          {/* changed as company profile */}
          <Route path="company-profile" element={<MaterialVendorAddProperty />} />
           <Route path="add-material" element={<ProtectedRoute><AddMaterialForm /></ProtectedRoute>} />
        <Route path="add-service" element={<ProtectedRoute><AddServiceForm /></ProtectedRoute>} />
          {/* <Route path="material-vendor" element={<ProtectedRoute><MaterialVendorAddProperty /></ProtectedRoute>} />
          <Route path="material-service" element={<ProtectedRoute><MaterialServiceAddProperty /></ProtectedRoute>} /> */}
          <Route path="group-chat" element={<Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // full viewport height
            }}
          >
            <img
              src="/assets/icons/maintainance.png" // your image path
              alt="Maintenance"
              style={{ maxWidth: "100%", width: 300, height: "auto" }}
            />
          </Box>} />
          <Route path="notifications" element={<Notifications />} />
          {/* <Route path="about-us" element={<h2>About Us Page</h2>} /> */}
        </Route>

        <Route path="add-property" element={<ProtectedRoute><AddPropertyForm /></ProtectedRoute>} />
        <Route path="/edit-property/:id" element={<ProtectedRoute><AddPropertyForm /></ProtectedRoute>} />
        <Route path="add-residential-property" element={<ProtectedRoute><AddResidential /></ProtectedRoute>} />
        <Route path="/edit-residential-property/:id" element={<ProtectedRoute><AddResidential /></ProtectedRoute>} />
       
        {/* 404 */}
        <Route path="*" element={<h2 className="text-center">Not found</h2>} />

      </Routes>
    </>

  );
};

export default AppRoutes;
